import cloneDeep from 'lodash/cloneDeep';
import React, { createRef, RefObject } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { IProvider, IProviders, ITags } from 'store/providers/providerTypes';
import { ITasks, RootState } from 'store/store';
import { ISearchParams, NumberOrNull, StringOrNull } from 'store/entity/types';
import { englishNumber, isANumber } from 'utils/number';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { redirectTo } from '@reach/router';
import ActionLink from 'components/ActionLink';
import Button from 'components/Button';
import { display } from 'components/ErrorView/ErrorDialog';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Select, { IOption } from 'components/Select/Select';
import ResponseForm from 'components/SurveyResponses/ResponseForm';
import TaskSearch from 'components/TaskSearch';
import { DropzoneRenderArgs } from 'react-dropzone';
import { getDomainAndPort } from '../../../../../api/Utils';
import { fixModalFootPrint } from '../../../../../containers/Mobile/Profile/MobileProfileContainer';
import ItemTask from '../../../../../containers/Profile/Panels/DocumentManager/ItemTask';
import { getRedirectToLoginPath } from '../../../../../utils/happyFunctions';
import { blue, white } from '../../../../../utils/style/colors';
import APopover from '../../../../APopover';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../../CKEditorField/CKEditorField';
import Input from '../../../../Input/Input';
import { default as Toast } from '../../../../Notify';
import { getTextFilterdQuestions } from '../../../../SurveyResponses/ResponseForm/ResponseForm';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from '../SurveyEditor/GeneralQuestion/styles';
import UniqueQuestion from '../SurveyEditor/UniqueQuestion';
import { IDistinctiveLabel } from '../SurveyEditor/UniqueQuestion/UniqueQuestion';
import DistinctiveBadges from './DistinctiveBadges';
import messages from './Messages';
import ResponseList from './ResponseList';
import {
  ClearSearchIcon,
  Description,
  DoneSubmit,
  LoadMoreResponsesContainer,
  LoadMoreText,
  ResponseListHeader,
  ResponseListWrapper,
  SearchIcon,
  SearchInput,
  SearchWrapper,
  surveyActionButtonStyle,
  ViewList,
  Wrapper,
} from './styles';
import ChartViewer from '../../../../Chart/ChartViewer';
import ChangeLimitationModal from '../../../../../containers/Profile/Panels/DocumentManager/ChangeLimitationModal';
import HoverIcon from '../../../../HoverIcon';
import { OpenItemsContext } from 'store/context/OpenItemsContext';
import {
  requireProviderTags,
  requireProviderTagsFn,
  searchProvider,
  searchProviderFn,
} from 'store/providers/providerSlice';
import { appDispatch } from 'store/store';
import { isCompanyOwnerOrSupport } from 'store/companies/companiesUtils';
import { IUsers } from 'store/users/usersType';
import {
  IAnswerView,
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyItem,
  ISurveyItemWithData,
  ISurveyResponseView,
  ISurveyView,
  ISurveyViewWithData,
  PeriodType,
  TimeScale,
} from 'store/survey/surveyTypes';
import { IThisUserState, logoutUser } from 'store/thisUser/thisUserSlice';
import { ICompany } from 'store/companies/companiesTypes';
import {
  addResponse,
  addResponseFn,
  exportResponses,
  exportResponsesFn,
  filterResponsesByDistinctive,
  filterResponsesByDistinctiveFn,
  getNotifications,
  getNotificationsFn,
  removeResponse,
  removeResponseFn,
  requireResponsesWithUsers,
  requireResponsesWithUsersFn,
  requireResponseWithId,
  requireResponseWithIdFn,
  updateResponse,
  updateResponseFn,
} from 'store/survey/surveySlice';
import { IAnalyticsListQuery } from 'store/entity/IAnalyticsListQuery';
import { IExportResponsesQuery } from 'store/entity/IExportResponsesQuery';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import {
  markTaskAssignment,
  markTaskAssignmentFn,
  searchTasks,
  searchTasksFn,
} from 'store/tasks/tasksSlice';
import { IAssignmentView } from 'store/tasks/tasksType';
import {
  getCompanyHandler,
  getCompanyHandlerFn,
} from 'store/companies/companiesSlice';
import { IQueryFilter } from 'store/entity/IQueryFilter';
import i18n, { languageDirection } from '../../../../../i18n';
import { ITaskSurveyResponse } from './ResponseItem';

interface IStateToProps {
  tags?: ITags['data'];
  users: IUsers['map'];
  analyseSurvey: ISurveyViewWithData;
  dataSurvey: ISurveyViewWithData;
  providers: IProviders;
  provider: IProviders['map'][0];
  tasks: ITasks;
  userRoles?: number[];
  canCreateTemplates: { id: number; title: string }[];
  allTemplatesWithRelatedItem: { id: number; title: string }[];
  thisUserId: number;
  thisUser: IThisUserState;
  providerId?: number;
  isAllResponsesLoaded: boolean;
  currentUserCompanyRoles: number[];
  company?: ICompany;
  isAdminOrSupport: boolean;
}

const savedDistinctiveValues: { [key: string]: string } | undefined = undefined;

const pageSize = 50;
interface IDispatchToProps {
  logOutUser: () => void;
  requireSeveralUser: (
    userIds: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;

  addResponse: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem,
    dontSendNotification: boolean,
    periodType: PeriodType
  ) => ReturnType<typeof addResponseFn>;
  getNotifications: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem
  ) => ReturnType<typeof getNotificationsFn>;
  removeResponse: (
    responseId: number,
    surveyItemData: ISurveyItem
  ) => ReturnType<typeof removeResponseFn>;
  updateResponse: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem,
    dontSendNotification: boolean
  ) => ReturnType<typeof updateResponseFn>;
  requireResponsesWithUsers: (
    surveyItemData: ISurveyItem,
    start: number,
    count: number,
    instance?: number,
    thisUserId?: number,
    order?: string
  ) => ReturnType<typeof requireResponsesWithUsersFn>;
  requireResponseWithId: (
    surveyItemData: ISurveyItem,
    responseId: number
  ) => ReturnType<typeof requireResponseWithIdFn>;
  filterResponses: (
    filters: IQueryFilter[]
  ) => ReturnType<typeof filterResponsesByDistinctiveFn>;
  searchProvider: (
    queryString: string,
    variant?: string | null,
    start?: number,
    count?: number
  ) => ReturnType<typeof searchProviderFn>;
  requireProviderTags: (
    providerId: number
  ) => ReturnType<typeof requireProviderTagsFn>;
  exportResponses: (
    dataQuery: IExportResponsesQuery,
    surveyToken?: string,
    ownerToken?: string,
    reportToken?: string
  ) => ReturnType<typeof exportResponsesFn>;
  searchTasks: (params: ISearchParams) => ReturnType<typeof searchTasksFn>;
  markTaskAssignment: (
    assignment: IAssignmentView
  ) => ReturnType<typeof markTaskAssignmentFn>;
  getCompany: (companyId: number) => ReturnType<typeof getCompanyHandlerFn>;
}

interface IOwnProps {
  analyseItem: ISurveyItemWithData;
  surveyItem: ISurveyItemWithData;
  filteredResponseId?: number;
}

type IComponentProps = IOwnProps & IDispatchToProps & IStateToProps;

interface IComponentState {
  from: number;
  loading: boolean;
  isUnique: boolean;
  periodType?: TimeScale;
  viewingPeriodType?: TimeScale;
  responseId?: number;
  disableForm: boolean;
  requestSent: boolean;
  forceAnalyse?: boolean;
  loadingSubmit?: boolean;
  showResponseForm: boolean;
  distinctiveValues?: { [key: string]: string };
  textFilterValues?: { [key: string]: string };
  distinctiveValuesForFilter?: { [key: string]: string };
  distinctiveLabels?: { [field: string]: IDistinctiveLabel };
  selectedResponseId: NumberOrNull;
  selectedProviderId?: number;
  showDistinctiveForm: boolean;
  showDoneSubmit: boolean;
  filteredResponsesIds?: number[];
  currentFilter?: IQueryFilter[];
  loadingExport: boolean;
  importWarningMessage?: string;
  sentResponseId?: number;
  filteredResponseId?: number;
  order: 'submitDate desc' | 'updateDate desc' | 'effectiveDate desc';
  showTaskModal?: {
    templateId?: number;
    responseId?: number;
    templateTitle?: string;
    taskId?: number;
    taskSurveyResponse?: ITaskSurveyResponse;
  };
  toImportFile?: File;
  randomInput?: boolean;
  isLimitationModalOpen: boolean;
}

class SurveyAnalyseViewer extends React.Component<
  IComponentProps,
  IComponentState
> {
  searchValue: any = React.createRef();
  responseListOrder = [
    {
      label: i18n.t('submitDate_desc', { ns: 'survey' }),
      value: 'submitDate desc',
    },
    {
      label: i18n.t('updateDate_desc', { ns: 'survey' }),
      value: 'updateDate desc',
    },
    {
      label: i18n.t('effectiveDate_desc', { ns: 'survey' }),
      value: 'effectiveDate desc',
    },
  ];

  constructor(props: IComponentProps) {
    super(props);
    const { analyseSurvey } = props;
    const surveyData = analyseSurvey.data;
    const isUnique = surveyData.keepUnique;
    const periodType = surveyData.periodType;
    this.state = {
      from: pageSize,
      loading: true,
      isUnique,
      responseId: undefined,
      periodType: periodType !== 'none' ? periodType : undefined,
      viewingPeriodType: periodType !== 'none' ? periodType : 'month',
      requestSent: false,
      disableForm: false,
      forceAnalyse: undefined,
      loadingSubmit: undefined,
      showResponseForm: false,
      distinctiveValues: savedDistinctiveValues,
      distinctiveValuesForFilter: savedDistinctiveValues,
      selectedResponseId: props.filteredResponseId || null,
      showDistinctiveForm: false,
      showDoneSubmit: false,
      selectedProviderId: undefined,
      loadingExport: false,
      order: 'updateDate desc' as const,
      filteredResponseId: props.filteredResponseId,
      isLimitationModalOpen: false,
    };
  }

  setOrder(order: IComponentState['order']) {
    this.setState({
      order: order as any,
      from: 0,
    });
    this.handleRequireResponses(0, order)();
  }
  includeScore: RefObject<HTMLInputElement> = createRef();

  componentDidUpdate(prevProps: Readonly<IComponentProps>) {
    if (prevProps.provider.isLoading !== this.props.provider.isLoading) {
      const hasAnyQuestionWithPermissionScheme =
        this.getHasAnyQuestionWithPermissionScheme();
      if (
        hasAnyQuestionWithPermissionScheme ||
        this.props.analyseItem.data.instanceType === 'User'
      ) {
        this.props.getCompany(this.props.provider.data!.managingCompanyId!);
      }
    }
    if (
      prevProps.analyseSurvey.data.periodType !==
      this.props.analyseSurvey.data.periodType
    ) {
      let p: TimeScale;
      switch (this.props.analyseSurvey.data.periodType) {
        case 'none':
          p = 'month';
          break;
        default:
          p = this.props.analyseSurvey.data.periodType || 'month';
      }
      this.setState({
        viewingPeriodType: p,
        periodType: p,
      });
    }
  }

  componentDidMount() {
    const {
      thisUserId,
      analyseItem,
      providerId,
      requireProviderTags,
      requireResponsesWithUsers,
      analyseSurvey,
    } = this.props;

    const visibilityStrategy = analyseSurvey.data.visibilityStrategy;
    if (
      !analyseItem.data.reportToken &&
      (!visibilityStrategy ||
        (visibilityStrategy === 'personal' && thisUserId) ||
        visibilityStrategy === 'open')
    ) {
      this.setState({
        showResponseForm: true,
        showDistinctiveForm: analyseSurvey.data.keepUnique,
        distinctiveValuesForFilter: this.state.distinctiveValues,
      });
    }
    const promises = [requireProviderTags(providerId as number)];
    if (thisUserId || this.canFetchAllResponses(analyseItem)) {
      const instance =
        analyseItem.data.instanceType === 'Provider'
          ? this.state.selectedProviderId
          : analyseItem.data.instanceType === 'User'
            ? (this.state.distinctiveValues &&
                this.state.distinctiveValues.instance &&
                Number(this.state.distinctiveValues.instance)) ||
              undefined
            : analyseItem.data.id;
      if (thisUserId)
        promises.push(
          requireResponsesWithUsers(
            analyseItem.data,
            0,
            pageSize,
            instance,
            thisUserId,
            this.state.order
          )
        );
    }
    const hasAnyQuestionWithPermissionScheme =
      this.getHasAnyQuestionWithPermissionScheme();
    if (
      !thisUserId &&
      (hasAnyQuestionWithPermissionScheme ||
        analyseItem.data.instanceType === 'User' ||
        analyseSurvey.data.uniquePerUser ||
        analyseSurvey.data.uniquePerInstance)
    ) {
      fixModalFootPrint();
      redirectTo(getRedirectToLoginPath());
      return;
    }
    if (!thisUserId && !analyseItem.data.reportToken) {
      this.setState({
        showResponseForm: true,
        distinctiveValuesForFilter: this.state.distinctiveValues,
      });
    }
    if (
      (hasAnyQuestionWithPermissionScheme ||
        analyseItem.data.instanceType === 'User') &&
      this.props.thisUser.userId &&
      this.props.provider.data?.managingCompanyId
    ) {
      promises.push(
        this.props.getCompany(this.props.provider.data.managingCompanyId)
      );
    }

    if (this.state.filteredResponseId) {
      if (
        !this.props.analyseSurvey.data.responseMap![
          this.state.filteredResponseId
        ]
      )
        this.props.requireResponseWithId(
          this.props.analyseItem.data,
          this.state.filteredResponseId
        );
    }
    Promise.allSettled(promises)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err) => {
        display(err);
      });
  }

  private getHasAnyQuestionWithPermissionScheme() {
    return this.props.analyseSurvey.data.versions[
      this.props.analyseSurvey.data.currentVersion
    ].questionMap
      ? Object.values(
          this.props.analyseSurvey.data.versions[
            this.props.analyseSurvey.data.currentVersion
          ].questionMap!
        )?.find((it) => {
          return (
            // @ts-expect-error it may have the prop
            it?.reportPermissionSchemeList?.length > 0 ||
            // @ts-expect-error it may have the prop
            it?.fillPermissionSchemeList?.length > 0
          );
        })
      : [];
  }

  canFetchAllResponses(survey: ISurveyItemWithData) {
    return (
      survey.data.changeDataToken ||
      survey.data.editToken ||
      survey.data.reportToken
    );
  }

  handleRequireResponses =
    (from?: number, order?: IComponentState['order']) => () => {
      const { thisUserId, analyseItem, requireResponsesWithUsers } = this.props;
      if (!thisUserId && !this.canFetchAllResponses(analyseItem)) {
        return;
      }
      this.setState({ requestSent: true });

      const realFrom = from !== undefined ? from : this.state.from;
      const instance =
        analyseItem.data.instanceType === 'Provider'
          ? this.state.selectedProviderId
          : analyseItem.data.id;
      requireResponsesWithUsers(
        analyseItem.data,
        realFrom,
        pageSize,
        instance,
        thisUserId,
        order || this.state.order
      ).then(
        () => {
          this.setState({
            requestSent: false,
            from: realFrom + pageSize,
          });
        },
        (err: any) => {
          this.setState({ requestSent: false });
          display(err);
        }
      );
    };

  handleChangeResponseViewer = (selectedResponseId: NumberOrNull) => {
    if (this.state.selectedResponseId === selectedResponseId)
      this.setState({ selectedResponseId: null });
    else this.setState({ selectedResponseId });
  };

  handleRemove = (responseId: number) => {
    const { removeResponse, analyseItem } = this.props;
    if (this.state.selectedResponseId === responseId) {
      this.setState({ selectedResponseId: null });
    }
    return removeResponse(responseId, analyseItem.data);
  };

  handleUpdateSurvey = (newResponse: ISurveyResponseView) => {
    const { updateResponse, analyseItem } = this.props;
    return updateResponse(newResponse, analyseItem.data, false);
  };

  handleSaveResponse = (
    answerList: ISurveyResponseView['surveyAnswerList'],
    type: 'create' | 'update' = 'create',
    draft: boolean,
    title: StringOrNull = null,
    dontSendNotification: boolean = false
  ) => {
    const {
      addResponse,
      updateResponse,
      analyseItem: { data },
    } = this.props;

    const response = this.createFinalResponse(type, answerList, title, draft);
    if (type === 'update') {
      return updateResponse(response, data, dontSendNotification);
    } else
      return addResponse(
        response,
        data,
        dontSendNotification,
        this.props.analyseSurvey.data.periodType
      );
  };

  private createFinalResponse(
    type: 'create' | 'update',
    answerList: ISurveyResponseView['surveyAnswerList'],
    title: StringOrNull,
    draft: boolean
  ) {
    const {
      analyseSurvey,
      analyseItem: { data },
    } = this.props;
    const { periodType, distinctiveValues } = this.state;

    const tagIDs =
      data.tags.length > 0
        ? data.tags.reduce((temp: number[], tag) => {
            temp.push(Number(tag.id));
            return temp;
          }, [])
        : [];
    let effectiveDate;
    if (periodType && distinctiveValues) {
      const timestamp = distinctiveValues[periodType];
      if (timestamp) {
        effectiveDate = Number(timestamp);
      }
    }
    if (type === 'update') {
      const responseId = Number(this.state.responseId);
      const response: ISurveyResponseView = cloneDeep(
        analyseSurvey.data.responseMap![responseId]
      );
      response.surveyAnswerList = answerList;
      response.tags = tagIDs;
      response.title = title;
      response.draft = draft;
      response.effectiveDate = effectiveDate;
      response.extraInfo = {
        itemId: data.id,
        providerId: data.providerId,
      };
      return response;
    } else {
      const newResponse: ISurveyResponseView = {
        draft,
        title,
        tags: tagIDs,
        instance:
          (distinctiveValues && Number(distinctiveValues.instance)) || data.id,
        surveyId: data.surveyId,
        surveyAnswerList: answerList,
        effectiveDate,
        surveyVersion: analyseSurvey.data.currentVersion,
        extraInfo: {
          itemId: data.id,
          providerId: data.providerId,
        },
        extraOwnerTokens: this.props.surveyItem.data.extraOwnerTokens,
      };
      return newResponse;
    }
  }

  handleGetNotifications = (
    answerList: ISurveyResponseView['surveyAnswerList'],
    type: 'create' | 'update' = 'create',
    draft: boolean,
    title: StringOrNull = null
  ) => {
    const {
      getNotifications,
      analyseItem: { data },
    } = this.props;
    const response = this.createFinalResponse(type, answerList, title, draft);
    return getNotifications(response, data);
  };

  // getAnalyse on creating/updating/deleting response
  handleAnalyse = (state: boolean) => () => {
    this.setState({ forceAnalyse: state });
  };

  handleResponseForm = (
    showResponseForm: boolean,
    showDoneSubmit: boolean,
    sentResponseId?: number
  ) => {
    // onCancel prop of ResponseForm
    const {
      showResponseForm: stateShowResponseForm,
      distinctiveValuesForFilter,
      distinctiveValues,
    } = this.state;
    const signOutOnFill =
      (
        this.props.analyseSurvey.data.fields.find(
          (x: any) => x.name === 'conf_signOutOnFill'
        ) || {
          value: 'false ',
        }
      ).value === 'true';
    const canReport = this.props.analyseItem.data.reportToken;
    if (showDoneSubmit && signOutOnFill && !canReport) {
      setTimeout(() => {
        this.props.logOutUser();
      }, 10000);
    }
    if (this.state.isUnique) {
      this.setState({
        responseId: undefined,
        forceAnalyse: !showResponseForm,
        showResponseForm: showResponseForm,
        showDistinctiveForm: showResponseForm,
        showDoneSubmit,
        sentResponseId,
      });
    }
    this.setState({
      responseId: undefined,
      forceAnalyse: !showResponseForm,
      showResponseForm: showResponseForm,
      showDoneSubmit,
      sentResponseId,
    });

    if (showResponseForm && !stateShowResponseForm) {
      this.setState({
        distinctiveValuesForFilter: distinctiveValues,
      });
    } else if (!showResponseForm && stateShowResponseForm) {
      this.setState({
        distinctiveValues: distinctiveValuesForFilter,
      });
    }
  };

  handleExport = () => {
    this.setState({ loadingExport: true });

    const exportOptions: IExportResponsesQuery = {
      filters: this.state.currentFilter || ([] as IQueryFilter[]),
      includeScore: this.includeScore!.current!.checked,
      includeEmptyResponse: false,
    };
    this.props
      .exportResponses(
        exportOptions,
        this.props.analyseItem.data.reportToken ||
          this.props.analyseItem.data.fillToken
      )
      .then(
        () => {
          this.setState({ loadingExport: false });
        },
        () => {
          this.setState({ loadingExport: false });
        }
      );
  };

  handleBackDistinctive = () => {
    let questionAnswered;
    const { distinctiveValues } = this.state;
    if (distinctiveValues) {
      const { currentDate, ...rest } = distinctiveValues;
      questionAnswered = Boolean(
        Object.values(rest).find((item) => item !== null)
      );
    }
    this.setState({
      responseId: undefined,
      showResponseForm: false,
      showDistinctiveForm: false,
      forceAnalyse: questionAnswered,
      distinctiveValues: this.state.distinctiveValuesForFilter,
    });
  };

  handleSetDistinctiveLabels = (
    labelChanges?: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[]
  ) => {
    if (labelChanges) {
      // label & order comes from input's data attributes
      const distinctiveLabels: {
        [field: string]: IDistinctiveLabel;
      } = this.state.distinctiveLabels
        ? cloneDeep(this.state.distinctiveLabels)
        : {};
      labelChanges.forEach((labelChange) => {
        const { distinctiveLabelItem, show } = labelChange;
        const { value } = distinctiveLabelItem;
        if (!show) {
          delete distinctiveLabels[value];
        } else {
          distinctiveLabels[value] = distinctiveLabelItem;
        }
      });
      this.setState({ distinctiveLabels });
    } else {
      // to reset distinctiveLabels
      this.setState({ distinctiveLabels: undefined });
    }
  };

  handleSetResponseId = (responseId: number) => (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();

      this.setState({
        responseId,
        showResponseForm: true,
        showDistinctiveForm: this.state.isUnique ? true : false,
        distinctiveValuesForFilter: this.state.distinctiveValues,
      });
    }
  };

  handleValues = (distinctiveValues: IComponentState['distinctiveValues']) => {
    this.setState({ distinctiveValues });
  };

  handleSubmitButton = (disableForm: boolean, loadingSubmit: boolean) => {
    this.setState({ disableForm, loadingSubmit });
  };

  handleSearchByResponseId = () => {
    let responseIdToSearch: number | undefined =
      this.searchValue.current.value &&
      Number(englishNumber(this.searchValue.current.value).replace(/\D/g, ''));
    if (!isANumber(responseIdToSearch)) {
      responseIdToSearch = undefined;
    }
    this.setState({ filteredResponseId: responseIdToSearch });
    if (responseIdToSearch) {
      if (!this.props.analyseSurvey.data.responseMap![responseIdToSearch])
        this.props.requireResponseWithId(
          this.props.analyseItem.data,
          responseIdToSearch
        );
    }
  };

  handleSearchProvider = (queryString: string) => {
    return new Promise((resolve, reject) => {
      this.props
        .searchProvider(queryString)
        .then(({ providers }) => {
          const searchResult = providers.reduce(
            (
              list: Array<{ id: number; title: string }>,
              provider: IProvider
            ) => {
              const item = {
                id: provider.id,
                title: provider.name || messages.withoutName,
              };
              list.push(item);
              return list;
            },
            []
          );
          return resolve(searchResult);
        })
        .catch((err: any) => {
          display(err);
          return reject();
        });
    });
  };

  handleSelectProvider = (providerId: string | number) => {
    this.setState({ selectedProviderId: providerId as number, from: 0 }, () =>
      this.handleRequireResponses(0)
    );
  };

  handleRemoveSelectedProvider = () => {
    this.setState({ selectedProviderId: undefined, from: 0 }, () =>
      this.handleRequireResponses(0)
    );
  };

  requestCounter = 0;
  handleFilterResponses =
    (hasSelectedDistinctive?: boolean) => async (filter: IQueryFilter[]) => {
      this.setState({ currentFilter: filter });
      // avoid analyseList on first render
      if (this.state.distinctiveValues || this.state.textFilterValues) {
        // avoid analyseList on deselect last distinctive item
        if (hasSelectedDistinctive) {
          this.requestCounter++;
          const myCount = this.requestCounter;
          return await this.props
            .filterResponses(filter)
            .then(({ filteredResponsesIds }) => {
              if (myCount === this.requestCounter)
                this.setState({
                  filteredResponsesIds,
                });
            });
        }
      }
    };

  handleCloseTaskModal = () => {
    this.setState({ showTaskModal: undefined });
  };

  handleShowTaskModal = (
    responseId?: number,
    templateId?: number,
    templateTitle?: string,
    taskId?: number,
    taskSurveyResponse?: ITaskSurveyResponse
  ) => {
    this.setState({
      showTaskModal: {
        templateId,
        responseId,
        templateTitle,
        taskId,
        taskSurveyResponse,
      },
    });
  };

  handleAcceptedFiles = (files: DropzoneRenderArgs['acceptedFiles']) => {
    const acceptedFile = files[0];
    this.setState({ toImportFile: acceptedFile });
  };

  handleRejectedFiles = () => {
    const warningMessage = messages.invalidFile;
    Toast(warningMessage, 'warning');
  };

  render() {
    const {
      tags,
      users,
      tasks,
      analyseSurvey,
      analyseItem,
      thisUserId,
      providers,
      isAllResponsesLoaded,
      provider,
      canCreateTemplates,
      allTemplatesWithRelatedItem,
      markTaskAssignment,
      thisUser,
      searchTasks,
      company,
      userRoles,
      currentUserCompanyRoles,
    } = this.props;
    const {
      from,
      loading,
      isUnique,
      periodType,
      viewingPeriodType,
      responseId,
      requestSent,
      forceAnalyse,
      showResponseForm,
      selectedResponseId,
      showDistinctiveForm,
      filteredResponsesIds,
      textFilterValues,
      filteredResponseId,
      order,
      loadingExport,
      showDoneSubmit,
      sentResponseId,
      showTaskModal,
      distinctiveValues,
      isLimitationModalOpen,
    } = this.state;

    const { domainFeatures } = getDomainAndPort();

    if (loading) {
      return (
        <div className="progress">
          <div className="indeterminate" />
        </div>
      );
    }

    let surveyResponseMap = analyseSurvey.data.responseMap!;
    const viewVersion = responseId
      ? surveyResponseMap[responseId].surveyVersion
      : showResponseForm
        ? analyseSurvey.data.currentVersion
        : analyseSurvey.viewingVersion!;

    const surveyQuestionMap =
      analyseSurvey.data.versions[viewVersion].questionMap;
    if (
      analyseItem.data.instanceType === 'Provider' &&
      this.state.selectedProviderId
    ) {
      surveyResponseMap = Object.entries(surveyResponseMap)
        .filter(
          (response) => response[1].instance === this.state.selectedProviderId
        )
        .reduce((initial, it) => {
          initial[it[0]] = it[1];
          return initial;
        }, {});
    }

    let answerList;
    let responseEffectiveDate;
    let hasSelectedDistinctive: boolean | undefined = undefined;

    if (surveyResponseMap && responseId) {
      answerList = surveyResponseMap[responseId].surveyAnswerList.reduce(
        (temp: { [questionId: string]: IAnswerView }, answer: IAnswerView) => {
          temp[answer.questionId] = answer;
          return temp;
        },
        {}
      );
      if (periodType) {
        responseEffectiveDate =
          surveyResponseMap[responseId].effectiveDate! * 1;
      }
    }

    const isValidForm =
      analyseItem.data.fillToken &&
      surveyQuestionMap &&
      (Object.values(surveyQuestionMap) as IQuestionsView[]).filter(
        (question: IQuestionsView | undefined) => !question!.deleted
      ).length !== 0;
    const visibilityStrategy = analyseSurvey.data.visibilityStrategy;
    const showAddButton =
      (isUnique
        ? isValidForm && !(showDistinctiveForm || showResponseForm)
        : !showResponseForm && isValidForm && thisUserId) &&
      (!visibilityStrategy ||
        (visibilityStrategy === 'protected' &&
          analyseItem.data.changeDataToken) ||
        (visibilityStrategy === 'personal' && thisUserId) ||
        visibilityStrategy === 'open');
    const user =
      surveyResponseMap && selectedResponseId
        ? users[surveyResponseMap![selectedResponseId!].userId!]
        : undefined;
    const showBackButton = isValidForm && !!thisUserId && showResponseForm;
    let foundDistinctiveQuestion = false;
    const distinctiveQuestions = (
      Object.values(surveyQuestionMap!) as IQuestionsView[]
    ).reduce(
      (obj: Record<string, any>, question: IQuestionsView | undefined) => {
        if (
          question!.type === 'multipleChoice' &&
          !question!.deleted &&
          (question!.distinctive ||
            (!showResponseForm && question!.showInTitle))
        ) {
          foundDistinctiveQuestion = true;
          obj[question!.id] = question as IMultipleChoiceQuestionView;
        }
        return obj;
      },
      {} as { [questoinId: number]: IMultipleChoiceQuestionView }
    );

    const hasDistinctiveValue = showResponseForm
      ? foundDistinctiveQuestion ||
        periodType ||
        analyseItem.data.instanceType === 'User'
      : true;
    const surveyDescription = analyseSurvey.data.description;
    const showUniqueQuestion = thisUserId
      ? hasDistinctiveValue
      : hasDistinctiveValue &&
        (showResponseForm || this.canFetchAllResponses(analyseItem));

    if (this.state.distinctiveValues) {
      const { currentDate, ...rest } = this.state.distinctiveValues;
      hasSelectedDistinctive = !Object.values(rest).every((o) => o === null);
    }

    let allResponses = {} as typeof surveyResponseMap;
    if (surveyResponseMap) {
      if (filteredResponseId) {
        allResponses = Object.entries(surveyResponseMap)
          .filter((r) => filteredResponseId === r[1].id)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      } else if (
        (hasSelectedDistinctive ||
          !Object.values(textFilterValues || {}).every((o) => o === null)) &&
        filteredResponsesIds
      ) {
        allResponses = Object.entries(surveyResponseMap)
          .filter((r) => filteredResponsesIds.includes(r[1].id!))
          .slice(0, from + pageSize)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      } else {
        allResponses = Object.entries(surveyResponseMap)
          .slice(0, from + pageSize)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      }
    }

    const getDoneSubmitView = () => {
      let message =
        (
          analyseSurvey.data.fields.find(
            (x: any) => x.name === 'conf_submitSuccessMessage'
          ) || {
            value: null,
          }
        ).value ||
        (i18n.t('doneSubmitResponseMessage', { ns: 'survey' }) as string);
      message = message.replace('%id%', sentResponseId!.toString());
      const actionTitle = (
        analyseSurvey.data.fields.find(
          (x: any) => x.name === 'conf_submitSuccessActionTitle'
        ) || {
          value: null,
        }
      ).value;

      const actionUrl = (
        analyseSurvey.data.fields.find(
          (x: any) => x.name === 'conf_submitSuccessActionUrl'
        ) || {
          value: null,
        }
      ).value;

      return (
        <div>
          <DoneSubmit>
            <Icon type="check" style={{ fontSize: '3rem' }} />
            <h4>{message}</h4>
            {actionTitle && actionUrl ? (
              <Button
                style={{ marginLeft: '1rem' }}
                onClick={() => {
                  window.location.href = actionUrl;
                }}
                color="red-outline"
              >
                {actionTitle}
              </Button>
            ) : (
              ''
            )}
            {thisUserId ? (
              <Button
                style={{ float: 'left' }}
                onClick={() => this.handleResponseForm(false, false)}
              >
                {i18n.t('showPrevResponses', { ns: 'survey' }) as string}
              </Button>
            ) : (
              <div />
            )}
          </DoneSubmit>
        </div>
      );
    };

    const textFilterQuestions = getTextFilterdQuestions(surveyQuestionMap!);
    const useRandomValues = this.state.randomInput;
    const handleShowTask = (taskId: number) =>
      this.handleShowTaskModal(undefined, undefined, undefined, taskId);
    const finalSelectedResponse =
      allResponses && Object.keys(allResponses).length === 1
        ? Object.values(allResponses)[0].id
        : selectedResponseId;

    return (
      <div className="modal-content flex-box" style={{ paddingBottom: '0' }}>
        {
          <Modal
            onClose={this.handleCloseTaskModal}
            title={
              showTaskModal?.templateTitle
                ? messages.addTask(showTaskModal?.templateTitle || '')
                : ''
            }
            isActive={!!showTaskModal}
          >
            {showTaskModal && showTaskModal.templateId && (
              <ItemTask
                companyId={provider.data!.managingCompanyId!}
                templateId={showTaskModal!.templateId}
                providerItem={analyseItem.data}
                tab={'info'}
                onClose={this.handleCloseTaskModal}
                fields={[
                  {
                    name: analyseItem.data.name + ' مرتبط',
                    title: analyseItem.data.name + ' مرتبط',
                    value: `${showTaskModal!.responseId}`,
                    type: 'analyseLink',
                    options: null,
                  },
                ]}
                taskId={'new'}
                onTaskCreate={(taskId: number) =>
                  this.handleShowTaskModal(
                    undefined,
                    undefined,
                    undefined,
                    taskId
                  )
                }
              />
            )}
            {showTaskModal && showTaskModal.taskId && (
              <ItemTask
                companyId={provider.data!.managingCompanyId!}
                taskId={showTaskModal.taskId}
                tab={'info'}
              />
            )}
          </Modal>
        }
        {isLimitationModalOpen && (
          <ChangeLimitationModal
            item={analyseItem}
            onComplete={() => {
              this.setState({ isLimitationModalOpen: false });
            }}
            managingCompanyId={this.props.company!.id}
            limitAccessToCompany={
              this.props.provider.data?.limitAccessToCompany
            }
          />
        )}
        {showDoneSubmit ? (
          getDoneSubmitView()
        ) : (
          <div>
            {!!thisUserId && (
              <span
                className={`hover-area ${languageDirection() === 'ltr' && 'row-reverse'}`}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
              >
                <h5
                  style={{ display: 'inline-block' }}
                  className="no-margin green-text text-darken-2"
                >
                  {i18n.t('analyse', { ns: 'survey' }) as string} «
                  {this.props?.dataSurvey?.data?.name}
                  »:
                </h5>
                {this.props.isAdminOrSupport && (
                  <OpenItemsContext.Consumer>
                    {(context) => (
                      <HoverIcon
                        type={'edit'}
                        color={blue}
                        className={'visible-on-hover'}
                        title={
                          i18n.t('showAnalyseSurvey', {
                            ns: 'survey',
                          }) as string
                        }
                        onClick={() => {
                          context.changeOpenItems(
                            analyseItem.data.id,
                            provider.data?.id || analyseItem.data.providerId
                          );
                        }}
                      ></HoverIcon>
                    )}
                  </OpenItemsContext.Consumer>
                )}
              </span>
            )}

            {showAddButton && (
              <div
                style={{
                  display: 'inline-flex',
                  gap: '10px',
                  float: languageDirection() === 'rtl' ? 'left' : 'right',
                }}
              >
                {this.props.analyseItem.data.editable && (
                  <Button
                    color="red-outline"
                    style={surveyActionButtonStyle}
                    onClick={() => {
                      this.setState({ isLimitationModalOpen: true });
                    }}
                  >
                    <Icon className="right" type="lock" />
                    {i18n.t('manageAnalyseAccess', { ns: 'survey' }) as string}
                  </Button>
                )}
                <Button
                  color="green"
                  style={surveyActionButtonStyle}
                  onClick={() => this.handleResponseForm(true, false)}
                >
                  <Icon className="right" type="plus-circle" />
                  {i18n.t('addNewAnalyse', { ns: 'survey' }) as string}
                </Button>
              </div>
            )}
            {showBackButton && (
              <Button
                color="green"
                onClick={() =>
                  isUnique
                    ? this.handleBackDistinctive()
                    : this.handleResponseForm(false, false)
                }
                style={surveyActionButtonStyle}
              >
                {i18n.t('showPrevResponses', { ns: 'survey' }) as string}
                <Icon
                  className="left"
                  type={
                    languageDirection() === 'rtl' ? 'arrow-left' : 'arrow-right'
                  }
                />
              </Button>
            )}
            {analyseItem.data.instanceType === 'Provider' && (
              <div className="row">
                <TaskSearch
                  onSearch={this.handleSearchProvider}
                  onSelect={this.handleSelectProvider}
                  placeholder={
                    i18n.t('searchProvider', { ns: 'survey' }) as string
                  }
                />
                {this.state.selectedProviderId && (
                  <React.Fragment>
                    <span>
                      {
                        i18n.t('filteredResponsesBasedOn', {
                          ns: 'survey',
                        }) as string
                      }
                      :{providers.map[this.state.selectedProviderId].data!.name}
                    </span>
                    <ActionLink
                      color="red"
                      onClick={this.handleRemoveSelectedProvider}
                    >
                      {i18n.t('clear', { ns: 'survey' }) as string}
                    </ActionLink>
                  </React.Fragment>
                )}
              </div>
            )}
            {surveyDescription && (
              <Description>
                <Icon
                  type="info"
                  style={{
                    fontSize: '3rem',
                    marginInlineEnd: '1rem',
                    color: white,
                  }}
                />
                <div style={{ flexGrow: 1 }}>
                  <CKEditorField
                    // editor={ClassicEditor}
                    data={surveyDescription.replace(/\n/g, '<br>')}
                    disabled={true}
                    dir="rtl"
                    config={CKEditorReadOnlyConfig}
                  />
                </div>
                {/*{surveyDescription}*/}
              </Description>
            )}
            {showUniqueQuestion && (
              <UniqueQuestion
                randomInput={useRandomValues}
                tags={tags}
                questions={distinctiveQuestions}
                periodType={periodType!}
                viewingPeriodType={viewingPeriodType}
                setViewingPeriodType={(e: TimeScale) => {
                  this.setState({ viewingPeriodType: e });
                }}
                responseId={responseId}
                version={analyseSurvey.data.currentVersion}
                surveyItem={analyseItem.data}
                isAnonymous={
                  !thisUserId && !this.canFetchAllResponses(analyseItem)
                }
                forceAnalyse={forceAnalyse}
                analyseComplete={this.handleAnalyse(false)}
                setChoicesValue={this.handleValues}
                showResponseForm={showResponseForm}
                surveyAnswerList={answerList}
                selectedInstance={
                  surveyResponseMap && responseId
                    ? surveyResponseMap[responseId].instance
                    : undefined
                }
                handleSubmitButton={this.handleSubmitButton}
                showDistinctiveForm={showDistinctiveForm}
                responseEffectiveDate={responseEffectiveDate}
                onSetDistinctiveLabels={this.handleSetDistinctiveLabels}
                onFilterResponses={this.handleFilterResponses(
                  hasSelectedDistinctive
                )}
                filterOnResponseForm
                visibilityStrategy={visibilityStrategy}
                currentUserCompanyRoles={currentUserCompanyRoles}
                distinctiveValues={showResponseForm ? {} : distinctiveValues}
                response={
                  surveyResponseMap && responseId
                    ? surveyResponseMap[responseId]
                    : undefined
                }
                userRoles={userRoles}
                survey={analyseSurvey.data}
                providers={this.props.providers}
              />
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                {this.state.distinctiveLabels && !showResponseForm && (
                  <DistinctiveBadges
                    distinctiveLabels={
                      Object.values(this.state.distinctiveLabels) as IOption[]
                    }
                  />
                )}

                {!showResponseForm && textFilterQuestions.length ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      minWidth: '310px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        columnGap: '10px',
                        overflow: 'auto',
                        padding: '0 5px',
                        margin: ' 0 0 0 10px',
                      }}
                    >
                      {textFilterQuestions.map((q) => {
                        return (
                          <Input
                            wrapperStyle={{ flexShrink: 0 }}
                            key={q.id}
                            id={'filter' + q.id}
                            type="text"
                            style={{ height: '30px' }}
                            value={this.state.textFilterValues?.[q.id] || ''}
                            onChange={(e) => {
                              this.setState({
                                textFilterValues: {
                                  ...this.state.textFilterValues,
                                  [q.id]: e.target.value,
                                },
                              });
                            }}
                            placeholder={q.title}
                            // label={q.title}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.keyCode === 13) {
                                this.handleSearchWithText();
                              }
                            }}
                          />
                        );
                      })}
                    </div>
                    <Button
                      onClick={this.handleSearchWithText}
                      color="blue-outline"
                      style={{ height: '30px' }}
                    >
                      <Icon type="search" />
                      {i18n.t('search', { ns: 'survey' }) as string}
                    </Button>
                  </div>
                ) : (
                  <div />
                )}
              </div>
              {!showResponseForm && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <APopover
                    arrow
                    curveBorder
                    placement="bottom-start"
                    trigger="click"
                    target={
                      <Button
                        color="green"
                        style={{
                          ...surveyActionButtonStyle,
                          display:
                            domainFeatures && domainFeatures.disableExcelExport
                              ? 'none'
                              : undefined,
                        }}
                        loading={this.state.loadingExport}
                      >
                        <Icon className="" type="download" />
                      </Button>
                    }
                  >
                    <div>
                      <h6
                        style={{ display: 'inline-block' }}
                        className="no-margin green-text text-darken-2"
                      >
                        {
                          i18n.t('downloadResponses', {
                            ns: 'survey',
                          }) as string
                        }
                      </h6>
                      <p className="switch">
                        <label>
                          <input
                            name="includeScore"
                            id="includeScore"
                            type="checkbox"
                            ref={this.includeScore}
                          />
                          <span
                            className="lever"
                            style={{
                              marginRight: '0',
                              marginLeft: '10px',
                            }}
                          />
                        </label>
                        {i18n.t('includeScore', { ns: 'survey' }) as string}
                      </p>
                      <Button
                        onClick={this.handleExport}
                        loading={loadingExport}
                        color="green"
                      >
                        {i18n.t('download', { ns: 'survey' }) as string}
                      </Button>
                    </div>
                  </APopover>
                </div>
              )}
            </div>
            <React.Fragment>
              <Wrapper>
                {showResponseForm ? (
                  <div
                    style={{
                      width: '50%',
                      height: 'calc(100vh - 150px)',
                      overflow: 'overlay',
                    }}
                  >
                    <ResponseForm
                      randomInput={useRandomValues}
                      isEditor={!!analyseItem.data.editToken}
                      askTitle={analyseSurvey.data.askTitle}
                      recommendRefill={analyseSurvey.data.recommendRefill}
                      submitMessage={
                        (
                          analyseSurvey.data.fields.find(
                            (x: any) => x.name === 'conf_submitSuccessMessage'
                          ) || {
                            value: '',
                          }
                        ).value
                      }
                      thisUserId={thisUserId}
                      userRoles={userRoles}
                      preventDraft={
                        (
                          analyseSurvey.data.fields.find(
                            (x: any) =>
                              x.name?.toLowerCase() === 'conf_allowdraft'
                          ) || {
                            value: 'true',
                          }
                        ).value?.toLowerCase() === 'false'
                      }
                      tags={tags}
                      setViewState={this.handleResponseForm}
                      singleResponseOnly={
                        !thisUserId || analyseSurvey.data.keepResponsesAnonymous
                      }
                      isUnique={foundDistinctiveQuestion}
                      response={
                        surveyResponseMap && responseId
                          ? surveyResponseMap[responseId]
                          : undefined
                      }
                      questions={surveyQuestionMap as any}
                      anonymous={analyseSurvey.data.keepResponsesAnonymous}
                      periodType={periodType || 'none'}
                      selectedPeriod={
                        this.state.distinctiveValues &&
                        Number(
                          this.state.distinctiveValues[periodType || 'none']
                        )
                      }
                      disableForm={this.state.disableForm}
                      loadingSubmit={this.state.loadingSubmit}
                      survey={analyseSurvey.data}
                      updateAnalyse={this.handleAnalyse(true)}
                      onSaveResponse={this.handleSaveResponse}
                      onGetNotifications={this.handleGetNotifications}
                      loadUsers={this.props.requireSeveralUser}
                      users={users}
                      distinctiveValues={this.state.distinctiveValues}
                      item={analyseItem}
                      company={company}
                      currentUserCompanyRoles={currentUserCompanyRoles}
                      openNextItem={() => {
                        /*do nothing*/
                      }}
                    />{' '}
                  </div>
                ) : surveyResponseMap ? (
                  <ResponseListWrapper halve={!!finalSelectedResponse}>
                    <ResponseListHeader>
                      <SearchWrapper>
                        <SearchInput
                          SearchWrapper
                          ref={this.searchValue}
                          type="text"
                          placeholder={
                            i18n.t('searchById', { ns: 'survey' }) as string
                          }
                          defaultValue={filteredResponseId}
                          onKeyDown={(event: KeyboardEvent) => {
                            if (event.keyCode === 13) {
                              this.handleSearchByResponseId();
                            }
                          }}
                        />
                        {filteredResponseId && (
                          <ClearSearchIcon
                            type="x"
                            onClick={() => {
                              this.searchValue.current.value = '';
                              this.handleSearchByResponseId();
                            }}
                          />
                        )}
                        <SearchIcon
                          type="search"
                          onClick={this.handleSearchByResponseId}
                        />
                      </SearchWrapper>
                      {/* <HeaderInfo>
                            {messages.loadedResponses(
                              convertNumbersToProperFormat(allResponses.size)
                            )}
                          </HeaderInfo>*/}
                      <Select
                        round={true}
                        onChangeValues={(e) => {
                          this.setOrder(e[0].value as any);
                        }}
                        allowRemove={false}
                        values={[
                          this.responseListOrder.find(
                            (it) => it.value === order
                          )!,
                        ]}
                        options={this.responseListOrder}
                      />
                    </ResponseListHeader>
                    <ResponseList
                      tags={tags}
                      item={analyseItem}
                      users={users}
                      canEdit={
                        !!analyseItem.data.editToken ||
                        !!analyseItem.data.changeDataToken
                      }
                      canEditSensitive={
                        !!analyseItem.data.editToken ||
                        (!analyseSurvey.data.sensitiveChangeRequiresEditor &&
                          !!analyseItem.data.changeDataToken)
                      }
                      onRemove={this.handleRemove}
                      onUpdate={this.handleUpdateSurvey}
                      thisUserId={thisUserId}
                      updateAnalyse={this.handleAnalyse(true)}
                      onEditResponse={this.handleSetResponseId}
                      onClickOnResponse={this.handleChangeResponseViewer}
                      createTask={this.handleShowTaskModal}
                      selectedResponseId={finalSelectedResponse}
                      order={order}
                      survey={analyseSurvey.data as ISurveyView}
                      responses={allResponses}
                      templates={canCreateTemplates}
                      expandable={true}
                      user={user}
                      surveyItem={analyseItem}
                      searchTasks={searchTasks}
                      tasks={tasks}
                      thisUser={thisUser}
                      hasRelatedTemplate={
                        allTemplatesWithRelatedItem.length > 0
                      }
                      markTaskAssignment={markTaskAssignment}
                      handleShowTask={handleShowTask}
                      company={company}
                      providers={providers}
                    />
                    <LoadMoreResponsesContainer>
                      <LoadMoreText>
                        {messages.loadedResponses(
                          allResponses
                            ? Object.keys(allResponses).length.toString()
                            : '0'
                        )}
                      </LoadMoreText>
                      {Object.keys(surveyResponseMap).length >= pageSize && (
                        <Button
                          color="green"
                          loading={requestSent}
                          onClick={this.handleRequireResponses()}
                          disabled={isAllResponsesLoaded}
                        >
                          {
                            i18n.t('previousResponses', {
                              ns: 'survey',
                            }) as string
                          }
                        </Button>
                      )}
                    </LoadMoreResponsesContainer>
                  </ResponseListWrapper>
                ) : (
                  <ViewList hiddenIfSmall={false}>
                    <QuestionHintBox
                      style={{
                        width: 'fit-content',
                        margin: 'auto',
                        marginTop: '20%',
                      }}
                    >
                      <HintIcon type="info" />
                      <HintText>
                        <span>
                          {(
                            analyseSurvey.data.fields.find(
                              (x: any) => x.name === 'conf_emptyMessage'
                            ) || {
                              value: null,
                            }
                          ).value ||
                            (i18n.t('thereIsNoAnswerYet', {
                              ns: 'survey',
                            }) as string)}
                        </span>
                      </HintText>
                    </QuestionHintBox>
                  </ViewList>
                )}
                {
                  <ViewList style={{ overflow: 'overlay' }}>
                    <ChartViewer
                      surveyId={this.props.dataSurvey.data.id}
                      surveyItem={this.props.surveyItem.data}
                      baseDate={
                        this.state.currentFilter?.find(
                          (it) => it.type === 'dateRangeFilter'
                        )?.end
                      }
                      extraFiltersIfNotSplit={this.state.currentFilter?.filter(
                        (it) => it.type !== 'dateRangeFilter'
                      )}
                      autoLoad={true}
                      viewType={'FullScreen'}
                      embedded={true}
                    />
                  </ViewList>
                }
              </Wrapper>
            </React.Fragment>
          </div>
        )}
      </div>
    );
  }

  handleSearchWithText = () => {
    const entries = Object.entries(this.state.textFilterValues || {}).filter(
      (it) => !!it[1]
    );
    this.setState({ textFilterValues: Object.fromEntries(entries) });
    const textFilters = entries.map((it) => {
      return {
        type: 'generalTermFilter',
        query: `allAnswers:${it[0]}$$*${it[1].replaceAll(' ', '\\ ')}*`,
        field: 'allAnswers',
      } as IQueryFilter;
    });
    const { distinctiveValues } = this.state;
    const hasDistinctiveFilter = !Object.values(distinctiveValues || {}).every(
      (o) => o === null
    );
    this.handleFilterResponses(hasDistinctiveFilter || !!textFilters.length)([
      ...(this.state.currentFilter || []).filter(
        (e) => e.type !== 'generalTermFilter'
      ),
      ...textFilters,
    ]);
  };
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const analyseSurvey = state.survey.data[props.analyseItem.data.surveyId];
  const dataSurvey = state.survey.data?.[props?.surveyItem?.data?.surveyId];
  const users = state.users.map;
  const providerId = props.analyseItem.data.providerId;
  const thisUser = state.thisUser;
  const thisUserId = Number(state.thisUser.userId);
  const tags = state.providers.tags[providerId]!.data;
  const providers = state.providers;
  const provider = providers.map[providerId];
  const isAllResponsesLoaded = analyseSurvey.allResponsesLoaded!;
  const companyId = provider.data!.managingCompanyId!;
  const company = companyId ? state.companies.data[companyId] : undefined;
  const userRoles = company?.members?.[thisUserId]?.roles
    ? Object.values(company.members[thisUserId].roles).map((item) => item.id)
    : [];
  const projects = company?.projects;
  const tasks = state.tasks;
  const canCreateTemplates: { id: number; title: string }[] = [];
  const allTemplatesWithRelatedItem: { id: number; title: string }[] = [];
  if (company && company.status === 'loaded') {
    const canCreateProjects = Object.values(projects || {}).filter(
      (project) => {
        const member = project.myMembership;
        return member ? member.canCreate : false;
      }
    );
    Object.values(company?.templates || {}).forEach((template) => {
      if (template.suggestOnDocumentManager) {
        const templateItem = {
          id: template.taskId,
          title: tasks.data[template.taskId].taskName,
        };
        allTemplatesWithRelatedItem.push(templateItem);
        if (
          canCreateProjects.find((project) =>
            project.templates.find((it) => it.taskId === template.taskId)
          )
        ) {
          canCreateTemplates.push(templateItem);
        }
      }
    });
  }
  const currentUserCompanyRoles: number[] = Object.keys(
    state.companies?.data?.[companyId!]?.members?.[thisUserId]?.roles || {}
  )?.map((it) => Number(it));

  const isAdminOrSupport =
    Number(thisUser.userId) === state.providers.map[providerId]!.data!.user ||
    (company && isCompanyOwnerOrSupport(thisUser, company, true))!;

  return {
    analyseSurvey,
    dataSurvey,
    userRoles,
    users,
    providerId,
    thisUserId,
    thisUser,
    tags,
    providers,
    provider,
    isAllResponsesLoaded,
    canCreateTemplates,
    allTemplatesWithRelatedItem,
    currentUserCompanyRoles,
    tasks,
    company: company ?? undefined,
    isAdminOrSupport,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IComponentProps
> = (_, props) => {
  return {
    addResponse: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem,
      dontSendNotification: boolean,
      periodType: PeriodType
    ) =>
      appDispatch(
        addResponse({
          response,
          surveyItemData,
          dontSendNotification,
          periodType,
        })
      ),
    getNotifications: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem
    ) => appDispatch(getNotifications({ response, surveyItemData })),
    removeResponse: (responseId: number, surveyItemData: ISurveyItem) =>
      appDispatch(removeResponse({ responseId, surveyItemData })),
    updateResponse: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem,
      dontSendNotification: boolean
    ) =>
      appDispatch(
        updateResponse({
          response,
          surveyItemData,
          dontSendNotification,
        })
      ),
    requireResponsesWithUsers: (
      surveyItemData: ISurveyItem,
      start: number,
      count: number,
      instance?: number,
      thisUserId?: number,
      order?: string
    ) =>
      appDispatch(
        requireResponsesWithUsers({
          surveyItemData,
          start,
          count,
          instance,
          thisUserId,
          order,
        })
      ),
    requireResponseWithId: (surveyItemData: ISurveyItem, responseId: number) =>
      appDispatch(
        requireResponseWithId({
          surveyItemData,
          responseId,
          includeDeletedResponse: true,
        })
      ),
    filterResponses: (filters: IAnalyticsListQuery['filters']) =>
      appDispatch(
        filterResponsesByDistinctive({
          filters,
          surveyItem: props.analyseItem.data,
        })
      ),
    searchProvider: (
      queryString: string,
      variant?: string | null,
      start?: number,
      count?: number
    ) =>
      appDispatch(
        searchProvider({
          queryString,
          variant,
          start,
          count,
        })
      ),
    requireProviderTags: (providerId: number) =>
      appDispatch(requireProviderTags({ providerId })),
    exportResponses: (
      query: IExportResponsesQuery,
      surveyToken?: string,
      ownerToken?: string,
      reportToken?: string
    ) =>
      appDispatch(
        exportResponses({
          dataQuery: query,
          surveyToken,
          reportToken,
          ownerToken,
        })
      ),
    logOutUser: () => appDispatch(logoutUser({ shouldRedirect: true })),
    requireSeveralUser: (userIds: number[]) =>
      appDispatch(requireSeveralUser({ usersList: userIds })),
    searchTasks: (params: ISearchParams) =>
      appDispatch(searchTasks({ params })),
    markTaskAssignment: (assignment: IAssignmentView) =>
      appDispatch(markTaskAssignment({ assignment })),
    getCompany: (companyId: number) =>
      appDispatch(
        getCompanyHandler({
          companyId,
          templateStub: false,
          companyStub: false,
          projectStub: false,
          taskStub: false,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyAnalyseViewer);
